import { icon } from './svgs'

import { useSocialSignIn } from '../../hooks/useSocialSignIn'

import { generateTagId } from '@/utils/test-automation'
import { cn } from '@/shared/utils'

import type { SignInTargetType } from '../../types'

interface SocialSignInButtonProps {
  text?: string
  target: SignInTargetType
  onlyIcon?: boolean
  align?: 'center' | 'left'
  onClick?: (target: SignInTargetType) => void
}

const SocialSignInButton = ({
  onlyIcon = false,
  text,
  target,
  align,
  onClick,
}: SocialSignInButtonProps): JSX.Element => {
  const { signIn } = useSocialSignIn()
  const iconName = !onlyIcon ? target : (`only_icon_${target}` as SignInTargetType)

  const handleClick = async () => {
    try {
      await signIn(target)
      if (onClick) {
        onClick(target)
      }
    } catch (e) {
      console.error('SocialSignInButton.handleClick', e)
    }
  }

  const Icon = icon[iconName]

  // 타겟별 스타일 클래스 생성
  const getTargetStyles = () => {
    switch (target) {
      case 'kakao':
        return 'bg-[#fee500] text-black'
      case 'apple':
        return 'bg-black text-white'
      case 'facebook':
        return 'bg-[#1877f2] text-white'
      case 'line':
        return 'bg-[#06c755] text-white'
      case 'google':
        return 'bg-white text-black border border-[#dadce0]'
      default:
        return ''
    }
  }

  return (
    <button
      id={generateTagId('login', 'section', 'btn', 'login', target)}
      data-testid={target}
      onClick={handleClick}
      className={cn(
        // 기본 스타일
        'flex items-center rounded-lg border-none cursor-pointer font-semibold text-lg w-full',
        // onlyIcon이 아닌 경우의 기본 스타일
        !onlyIcon && [
          'w-full h-14 px-4 shadow-sm',
          align === 'center' ? 'justify-center gap-2' : 'justify-start gap-2.5',
        ],
        // onlyIcon인 경우의 스타일
        onlyIcon && ['w-9 h-9 p-0 bg-transparent shadow-none inline-block'],
        // 타겟별 색상 스타일
        !onlyIcon && getTargetStyles(),
        'social-sign-in-button',
      )}
    >
      <Icon />
      {!onlyIcon && text}
    </button>
  )
}

export default SocialSignInButton
